import { render } from "./SidebarItem.vue?vue&type=template&id=a1c6b354"
import script from "./SidebarItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarItem.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/SidebarItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a1c6b354"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a1c6b354', __exports__)) {
    api.reload('a1c6b354', __exports__)
  }
  
  module.hot.accept("./SidebarItem.vue?vue&type=template&id=a1c6b354", () => {
    api.rerender('a1c6b354', render)
  })

}


export default __exports__